import { render } from "./SideBar.vue?vue&type=template&id=169de34a&ts=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__